import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./similarProducts.module.css";
import { LeftArrow, RightArrow } from "../../../Svg";
import { useNavigate } from "react-router-dom";
import { useCurrency } from '../../context/CurrencyContext';


const CustomArrow = ({ className, onClick, arrowDirection }) => {
  return (
    <div
      className={`${className} ${styles.customArrow} ${arrowDirection === "left" ? styles.leftArrow : styles.rightArrow
        }`}
      onClick={onClick}
    >
      {arrowDirection === "left" ? <LeftArrow /> : <RightArrow />}
    </div>
  );
};

const SimilarProducts = ({ similarProducts }) => {

  const navigate = useNavigate();
  const { formatPrice } = useCurrency();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4, // Display 4 products per slide
    slidesToScroll: 1,
    prevArrow: <CustomArrow arrowDirection="left" />,
    nextArrow: <CustomArrow arrowDirection="right" />,
    adaptiveHeight: true,
    autoplay: true, // Enable auto-play
    autoplaySpeed: 2000, // Set auto-play speed in milliseconds (3 seconds)
    pauseOnHover: true, // Pause auto-play on hover
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 546,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className={styles.sliderContainer}>
      <h2 className={styles.heading}>Similar Products</h2>
      {similarProducts?.similarProducts?.length > 0 ? (
        <Slider {...settings} className={styles.slickSlider} style={{ gap: "16px", width: "100%" }}>
          {similarProducts?.similarProducts?.map((product) => {
            const basePrice = product?.pricing?.finalSalePrice?.value;
            const discountPercentage = product?.discount?.discountValue || 0
            const finalPrice = basePrice - (basePrice * discountPercentage / 100)
            return (
              <div key={product._id} className={styles.productCard} style={{ cursor: 'pointer' }}
                onClick={() => {
                  navigate(`/prodDescription/${product?._id}`);
                  window.scrollTo(0, 0);
                }}
              >
                <div className={styles.productmain}>
                  <div className={styles.productimgcont}>
                    <div key={product.id} className={styles.productImage}>
                      <img
                        src={product.featurerdImage}
                        alt={product.productName}
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                    <p className={styles.productName}>{product.productName}</p>
                    <p className={styles.productPrice}>
                      <span className={styles.currentPrice}>{formatPrice(product?.sellingPrice)}</span>
                      {discountPercentage === 0 ? (
                        null
                      ) : (
                        <span className={styles.originalPrice}>
                          {formatPrice(product?.totalPrice)}
                        </span>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            )
          })}
        </Slider>
      ) : (
        <div>No similar products available</div>
      )}
    </div>
  );
};

export default SimilarProducts;
